import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'

import './CollapseLabel.css';


class CollapseLabel extends Component {
  clickHandler() {
    if (!this.props.onClick) {
      return
    }
    const prevOpened = this.props.isOpened
    this.props.onClick(prevOpened)
  }

  render() {
    return <div
      className='CollapseLabel'
      onClick={() => this.clickHandler()}>
      <FontAwesomeIcon icon={this.props.isOpened ? faCaretDown : faCaretRight} />
      {this.props.title || 'ラベル名'}
    </div>
  }
}

export default CollapseLabel;
